import { Evaluator } from 'vymo-jsevaluator';

export const evaluate = new Evaluator();
